import { useQuery } from "@tanstack/react-query";
import { getWallet } from "../wallet";
import { useAccount, viewingConnectedAgent } from "./account";
import { decideChainAction } from "./chain";
import { WalletType } from "../shared/wallet";
import { useChainStore } from "../shared/store";
import { isCosmosAccount, isEthereumAccount, } from "../shared/account";
export { getWallet } from "../wallet";
export { WalletType } from "../shared/wallet";
/**
 * Preferred Wallet Order
 *
 * Use a record to obtain type exhausting
 */
const preferredWalletOrder = {
    [WalletType.metamask]: 0,
    [WalletType.leap]: 1,
    [WalletType.keplr]: 2,
    [WalletType.xdefi]: 3,
    [WalletType.cosmostation]: 4,
    [WalletType.okx]: 5,
    [WalletType.compass]: 6,
    [WalletType.viewing]: 7,
    [WalletType.walletConnect]: 8,
    [WalletType.leapMobile]: 9,
    [WalletType.keplrMobile]: 10,
    [WalletType.cosmostationMobile]: 11,
    [WalletType.vultisig]: 12,
};
export const getSupportedWallets = () => {
    const availableWallets = [];
    const walletTypes = Object.entries(preferredWalletOrder).sort(([, a], [, b]) => a - b);
    const { chainId } = useChainStore.getState();
    for (const [walletType] of walletTypes) {
        if (walletType === WalletType.walletConnect ||
            walletType === WalletType.leapMobile ||
            walletType === WalletType.keplrMobile ||
            walletType === WalletType.cosmostationMobile) {
            // currently not supported
            continue;
        }
        const walletInfo = getWallet(walletType).info;
        if (walletInfo.isChainSupported(chainId)) {
            availableWallets.push(walletType);
        }
    }
    return availableWallets;
};
export const isMobileWallet = (walletType) => {
    switch (walletType) {
        case WalletType.compass:
        case WalletType.cosmostation:
        case WalletType.keplr:
        case WalletType.leap:
        case WalletType.metamask:
        case WalletType.okx:
        case WalletType.viewing:
        case WalletType.xdefi:
            return false;
        case WalletType.cosmostationMobile:
        case WalletType.keplrMobile:
        case WalletType.leapMobile:
        case WalletType.vultisig:
        case WalletType.walletConnect:
            return true;
    }
};
// TODO: move to account. rename to useConnectedAgent
export const useConnectedWallet = (args) => {
    const defaultChainId = useChainStore((state) => state.chainId);
    const activeChainId = args?.chainId ?? defaultChainId;
    const rpc = useChainStore((state) => {
        return state.chains.find((chain) => chain.chainId === activeChainId)?.rpc;
    });
    const { data: account } = useAccount(activeChainId);
    return useQuery({
        queryKey: [
            "useConnectedWallet",
            activeChainId,
            account,
            rpc,
            args?.inboundAddress?.address,
        ],
        enabled: account !== undefined && activeChainId.length > 0,
        queryFn: async () => {
            if (account && activeChainId) {
                if (account.walletType === WalletType.viewing) {
                    return viewingConnectedAgent(account);
                }
                const action = await decideChainAction({
                    chainId: activeChainId,
                    cosmos: async () => {
                        if (isCosmosAccount(account)) {
                            const { cosmosConnectedAgent } = await import("../cosmos/account");
                            return cosmosConnectedAgent(account);
                        }
                    },
                    injective: async () => {
                        if (isCosmosAccount(account) || isEthereumAccount(account)) {
                            const { injectiveConnectedAgent } = await import("../injective/account");
                            return injectiveConnectedAgent(account);
                        }
                    },
                    rujira: async () => {
                        const { rujiraConnectedAgent } = await import("../rujira/account");
                        return rujiraConnectedAgent(account, args?.inboundAddress);
                    },
                });
                const connectedAgent = await action();
                if (connectedAgent) {
                    return connectedAgent;
                }
                throw new Error(`Unhandled connectedAgent with walletType: ${account.walletType} and chainId: ${account.chainId}`);
            }
        },
    });
};
//# sourceMappingURL=wallet.js.map